import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'AgentLogin',
    component: () => import('../views/AgentLogin.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'AgentWorkbench',
    component: () => import('../views/AgentWorkbench.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

// 路由守卫：未登录跳登录页
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ name: 'AgentLogin', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
